import { SvgIcon, SvgIconProps } from '@mui/material';

/** @deprecated Use theme-next icons or move into theme-next folder if it doesn't exists */
export const CloseIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 20 20" htmlColor={props.htmlColor ?? '#F94264'} {...props}>
            <path d="M15.8333 5.34163L14.6583 4.16663L9.99996 8.82496L5.34163 4.16663L4.16663 5.34163L8.82496 9.99996L4.16663 14.6583L5.34163 15.8333L9.99996 11.175L14.6583 15.8333L15.8333 14.6583L11.175 9.99996L15.8333 5.34163Z" />
        </SvgIcon>
    );
};
